import {Dictionary} from 'vuex'
import {VueConstructor} from 'vue'

interface ActiveInfoPageBlockConfig {
  block: VueConstructor,
  options?: any
}

export interface ActiveInfoPageConfig {
  mapsColumns: { [key: string]: string[][] },
  blocks: Dictionary<ActiveInfoPageBlockConfig>,
  styles?: {[key: string]: string}
}

export const Sizes: { [key: string]: number } = {
  xs: 500,
  sm: 728,
  md: 880,
  lg: 1160
}